import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7cf0561f")

_pushScopeId("data-v-7cf0561f")
const _hoisted_1 = { class: "general-settings" }
const _hoisted_2 = { class: "setting-wrap" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h1", { class: "title" }, "Settings", -1)
const _hoisted_4 = { class: "setting-list" }
const _hoisted_5 = { class: "content" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icon = _resolveComponent("Icon")
  const _component_RadioInput = _resolveComponent("RadioInput")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "close",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.hiddenModal && _ctx.hiddenModal(...args)))
    }, [
      _createVNode(_component_Icon, {
        name: "ic16-close",
        color: "--sui-gray-500"
      })
    ]),
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("ul", _hoisted_4, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listSetting, (item) => {
          return (_openBlock(), _createBlock("li", null, [
            _createVNode(_component_RadioInput, {
              class: ["setting-item", { active: _ctx.currentTab === item }],
              item: item,
              name: "settings",
              onClick: ($event: any) => (_ctx.currentTab = item),
              key: item,
              checked: _ctx.currentTab === item
            }, null, 8, ["item", "onClick", "class", "checked"])
          ]))
        }), 256))
      ])
    ]),
    _createVNode("div", _hoisted_5, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentTab), { class: "tab" }))
    ])
  ]))
})